<system-notifications [location]="'login'"></system-notifications>

<div
  *ngIf="psd2LoginBannerEnabled && step === 1"
  class="psd2Banner"
  data-component="alert-message"
  [data]="{
    category: 'information',
    message:
      '<h4>How you log in and manage your account is changing</h4><p>To keep your account secure we’ll be making some changes to the way you log in and manage your account. These changes mean you may be asked to enter a one-time passcode when you log in or use certain features within Online Account Manager.</p>'
  }"
></div>

<div class="authentication-content clearfix">
  <div class="row horiz-line">
    <div class="col-sm-6">
      <h1 *ngIf="step == 1" class="h2 text-primary">Online Account Manager</h1>
      <h1 *ngIf="step == 2" class="h2 text-primary">Enter your Passcode</h1>
      <p>
        Manage your account with the Online Account Manager any time, any place.
      </p>
      <br />
      <p *ngIf="step == 1">
        Not yet registered for Online Account Manager?
        <a
          (click)="trackGAEvents(GTMTracking.LoginSignUpHereClick)"
          [routerLink]="registerLink.url"
          attr.aria-label="{{ registerLink.text }}"
          tabindex="1"
          >{{ registerLink.text }}</a
        >
      </p>
    </div>
    <div class="login-form-col col-sm-6">
      <form
        [formGroup]="loginForm"
        (ngSubmit)="submitLogin()"
        class="form-group"
        [invalidInputFocus]="loginForm"
        autocomplete="off"
      >
        <div
          data-component="validation-messages"
          [screenreaderErrorMessages]="screenreaderErrorMessages"
          [errors]="errors"
          [renderValidationSummary]="false"
        ></div>

        <div
          *ngIf="step == 1"
          class="userCredentials"
          formGroupName="userCredentials"
        >
          <div class="form-group-control">
            <span class="pull-right forgotElement">
              <a
                (click)="trackGAEvents(GTMTracking.LoginClickForgottenUsername)"
                [attr.id]="forgotUsernameLink.id"
                [routerLink]="forgotUsernameLink.url"
                [attr.aria-label]="forgotUsernameLink.text"
                tabindex="7"
                >{{ forgotUsernameLink.text }}</a
              >
            </span>
            <label for="j_username">Username</label>
            <div class="password-wrapper">
              <input
                id="j_username"
                name="j_username"
                [attr.type]="usernameInputHidden ? 'password' : 'text'"
                [ngClass]="{ error: credentialFieldHasError('userName') }"
                [attr.aria-describedby]="
                  credentialFieldHasError('userName') ? 'usernameError' : null
                "
                [attr.aria-invalid]="credentialFieldHasError('userName')"
                formControlName="userName"
                placeholder="Username"
                autocomplete="off"
                aria-required="true"
                value=""
                maxlength="254"
                required
                data-test-id="input-username"
                tabindex="2"
              />
            </div>

            <div id="usernameError" aria-live="polite" role="alert">
              <span
                *ngIf="
                  credentialFieldHasError('userName') &&
                  credentialFieldHasRequiredError('userName')
                "
                class="error-msg"
                data-test-id="text-inline-required-username"
              >
                Username is required
              </span>
            </div>
          </div>

          <div class="form-group-control">
            <span class="pull-right forgotElement">
              <a
                (click)="trackGAEvents(GTMTracking.LoginClickForgottenPassword)"
                [attr.id]="forgotPasswordLink.id"
                [routerLink]="forgotPasswordLink.url"
                [attr.aria-label]="forgotPasswordLink.text"
                tabindex="8"
                >{{ forgotPasswordLink.text }}</a
              >
            </span>
            <label for="j_password">Password</label>
            <div class="password-wrapper">
              <input
                id="j_password"
                name="j_password"
                [attr.type]="passwordInputHidden ? 'password' : 'text'"
                [ngClass]="{ error: credentialFieldHasError('password') }"
                [attr.aria-describedby]="
                  credentialFieldHasError('password') ? 'passwordError' : null
                "
                [attr.aria-invalid]="credentialFieldHasError('password')"
                formControlName="password"
                placeholder="Password"
                autocomplete="off"
                aria-required="true"
                value=""
                required
                data-test-id="input-password"
                tabindex="3"
              />

              <show-password-toggle
                (isHiddenChanged)="changePasswordInputVisibility($event)"
                [tabindex]="4"
              >
              </show-password-toggle>
            </div>

            <div id="passwordError" aria-live="polite" role="alert">
              <span
                *ngIf="
                  credentialFieldHasError('password') &&
                  credentialFieldHasRequiredError('password')
                "
                class="error-msg"
                data-test-id="text-inline-required-password"
              >
                Password is required
              </span>
            </div>
          </div>
        </div>

        <div *ngIf="step == 2" class="step2">
          <div class="form-group-control">
            <span class="passcodeLink pull-right">
              <a
                (click)="trackGAEvents(GTMTracking.LoginClickForgottenPassCode)"
                [attr.id]="forgotPasscodeLink.id"
                [routerLink]="forgotPasscodeLink.url"
                [attr.aria-label]="forgotPasscodeLink.text"
                tabindex="2"
                >{{ forgotPasscodeLink.text }}</a
              >
            </span>
            <p class="mock-label">Enter passcode</p>
            <passcode-input
              [passcodeInputs]="passcodeInputs"
              [name]="'loginPasscode'"
              [ariaDescribedBy]="'passcodeError'"
              [labelPrefix]="'Enter your 6 digit passcode'"
              [isToggleable]="true"
              [inputTabindex]="1"
              formControlName="passcode"
              #passcodeComponent
              (onChangePasscodeVisibility)="
                trackGAEvents(GTMTracking.LoginRevealPassCode)
              "
            ></passcode-input>

            <div id="passcodeError" aria-live="polite" role="alert">
              <span
                *ngIf="formDirty && !passcodeComponent.inputted"
                class="error-msg"
                data-test-id="text-inline-required-passcode"
              >
                Passcode is required
              </span>
              <span
                *ngIf="
                  formDirty &&
                  passcodeComponent.inputted &&
                  !passcodeComponent.valid
                "
                class="error-msg"
                data-test-id="text-inline-invalid-passcode"
              >
                Passcode is invalid
              </span>
            </div>
          </div>
        </div>

        <div
          *ngIf="(cookiePreferences | async)?.userPreferences"
          [ngClass]="{ invisible: step != 1 }"
        >
          <div class="form-group-control">
            <div class="checkbox-wrapper">
              <input
                id="rememberMe"
                name="rememberMe"
                type="checkbox"
                formControlName="rememberMe"
                data-test-id="input-rememberme"
                aria-describedby="btnIsPublicDevice"
                tabindex="5"
              />
              <label for="rememberMe"> Remember my username </label>
            </div>
          </div>

          <p id="btnIsPublicDevice" class="text-primary">
            Don't tick this box if you're using a public or shared device
          </p>
        </div>

        <span
          *ngIf="
            (credentialsMessage.message || credentialsMessage.linkText) &&
            credentialsMessage.url
          "
          class="error-msg"
        >
          {{ credentialsMessage.message }}
          <a
            class="error-msg"
            [href]="credentialsMessage.url"
            data-test-id="button-credentials-message"
            [attr.data-detail]="credentialsMessage.detail"
            >{{ credentialsMessage.linkText }}</a
          >
        </span>

        <span
          *ngIf="credentialsMessage.message && !credentialsMessage.url"
          data-test-id="text-credentials-message"
          class="error-msg"
          [attr.data-detail]="credentialsMessage.detail"
        >
          {{ credentialsMessage.message }}
        </span>

        <div
          *ngIf="errorService.errors != null"
          aria-live="polite"
          role="alert"
        >
          <div *ngFor="let error of errorService.errors">
            <span
              *ngIf="
                error.link != null &&
                (error.data != null || error.linkText != null) &&
                !error.shouldInjectLink
              "
              class="error-msg"
            >
              {{ error.data }}
              <a
                class="error-msg"
                *ngIf="error.link"
                [href]="error.link"
                data-test-id="text-server-error-with-link"
                >{{ error.linkText }}</a
              >
            </span>

            <span
              *ngIf="
                error.link != null &&
                (error.data != null || error.linkText != null) &&
                error.shouldInjectLink
              "
              class="error-msg"
            >
              <span [innerHTML]="error.data"></span>
            </span>

            <span
              *ngIf="error.link == null && error.data != null"
              class="error-msg"
              data-test-id="text-server-error-without-link"
            >
              {{ error.data }}
            </span>
          </div>
        </div>

        <div *ngIf="loginError" class="error" aria-live="polite">
          We are currently experiencing some technical difficulties. We’re aware
          of the problem and we’re working hard to resolve it as soon as
          possible. Please try again later.
        </div>

        <button
          type="submit"
          [id]="step == 1 ? 'loginStep1' : 'loginStep2'"
          [ngClass]="{
            'btn btn-primary btn-login': true,
            loading: isSubmitting
          }"
          disabled="disabled"
          [disabled]="!loginReady || isSubmitting"
          [attr.aria-label]="isSubmitting ? 'loading' : null"
          aria-disabled="false"
          data-test-id="button-login"
          [attr.aria-describedby]="
            (getCredentialsFormGroup() &&
              (getCredentialsFormGroup().dirty ||
                getCredentialsFormGroup().touched) &&
              !getCredentialsFormGroup().valid) ||
            (step == 2 && passcodeComponent && !passcodeComponent.valid) ||
            credentialsMessage.srMessage
              ? 'sr-errors'
              : null
          "
          tabindex="6"
        >
          Log in
        </button>
      </form>
    </div>
  </div>

  <div
    *ngIf="step === 1 && mobileLinksEnabled && (appStoreLink || googlePlayLink)"
    class="mobileAppLinks"
  >
    <hr />
    <h2>Mobile App</h2>
    <div class="row">
      <div class="col-md-7">
        <p>
          For the best experience and access to the latest features, download
          the {{ mobileAppName }} app today
        </p>
      </div>
      <div class="col-md-5 logos">
        <a
          *ngIf="appStoreLink"
          [href]="appStoreLink"
          target="_blank"
          title="Opens App Store page in new window"
        >
          <img
            src="{{ buildRoot }}/assets/{{ brand }}/img/app-store.svg"
            alt="App Store logo"
        /></a>
        <a
          *ngIf="googlePlayLink"
          [href]="googlePlayLink"
          target="_blank"
          title="Opens Google Play page in new window"
        >
          <img
            src="{{ buildRoot }}/assets/{{ brand }}/img/google-play.svg"
            alt="Google play logo"
          />
        </a>
      </div>
    </div>
  </div>
</div>

<upl-banner *ngIf="step === 1"></upl-banner>
